import { signal } from "@preact/signals-react";
import {
  logClientNumber,
  logClientCompany,
  logToken,
} from "./login.signal";

export const homeData = signal(null);
export const isOffer = signal(null);

export async function fetchHomeApi() {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchHomeData.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      origin: "http://alguthmi.co",
    },
    body: JSON.stringify({
      LANG: 1,
      CLICODE: logClientNumber.value,
      SOCCODE: logClientCompany.value,
    }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}
